<template>
  <UiBaseIcon width="12" height="12" :color="color" icon-name="filterColumn" />
</template>

<script>
import syncQuery from '@/mixins/syncUrlQuery'

import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: { UiBaseIcon },
  mixins: [syncQuery],
  props: {
    queryKeys: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    /**
     * Filter icon (in table header) color;
     *
     * ACTIVE_COLOR — if filter is active.
     * DISABLE_COLOR — else.
     */
    color() {
      const ACTIVE_COLOR = '#007AFF'
      const DISABLE_COLOR = '#BFBFBF'

      return this.queryKeys.find(this.hasQuery) ? ACTIVE_COLOR : DISABLE_COLOR
    },
  },
}
</script>
